import { icon } from '../lib/icons';
import type { RouteHandler } from '../lib/router';
import { renderPageShell } from '../lib/page-shell';

/** Stack Tower's own mode menu — reached from "Choose Your Game" (play-menu.ts), establishing Stack Tower as its own game rather than a handful of entries buried inside Stop the Clock's menu. */
export const renderStackTowerMenu: RouteHandler = (container, navigate) => {
  renderPageShell(container, navigate, 'play', {
    title: 'STACK TOWER',
    subtitle: 'Tap to place. Only the overlap survives. How high can you climb?',
    body: `
      <div class="play-mini-row">
        <button class="choice-mini" type="button" data-nav="stack-tower">
          <span class="mode-icon mode-icon--mini">${icon('tower')}</span>
          <span><strong>Solo</strong><small>No clock. A miss ends your run. How high can you climb?</small></span>
        </button>
        <button class="choice-mini" type="button" data-nav="stack-tower-60">
          <span class="mode-icon mode-icon--mini">${icon('clock')}</span>
          <span><strong>60 Second</strong><small>A miss costs your tower, not your run. Race the clock.</small></span>
        </button>
        <button class="choice-mini" type="button" data-nav="stack-tower-online">
          <span class="mode-icon mode-icon--mini">${icon('people')}</span>
          <span><strong>Head to head</strong><small>Room code, split screen, 60 Second or Endless.</small></span>
        </button>
        <button class="choice-mini" type="button" data-nav="stack-tower-ranked">
          <span class="mode-icon mode-icon--mini">${icon('practice')}</span>
          <span><strong>Ranked</strong><small>Sign in, get matched, rating updates after.</small></span>
        </button>
      </div>
    `,
  });
};
